module.exports = __webpack_public_path__ + "img/lv.61950beb.png";